import { getStorageKey } from "../../../helpers/utils";

//TODO: refactor and cleanup
/// currently we have some preferences that are saved via updateSettings in the testing_preferences json

const updateTestPreferences = (controller, settings, cb = () => {}) => {
  const action = {
    action: "save",
    target: "testing",
    ...settings,
  };
  controller.apiService.cardAction(action).then(cb);
};

const updatePreferences = (controller, settings, cb = () => {}) => {
  //const oldSettings = controller.state?.settings || {};
  //const newSettings = { ...oldSettings, ...settings };

  const action = {
    action: "save",
    target: "preferences",
    ...settings,
  };
  controller.apiService.cardAction(action).then(cb);
};

const updateSetupProgress = (controller, data = {}) => {
  const oldSetup = getCurrentSetupProgress(controller);
  updateTestPreferences(
    controller,
    { onboarding_step: { ...oldSetup, ...data } },
    () => {
      controller.getItems();
    },
  );
};

const getCurrentSetupProgress = (controller) => {
  //const settings = controller.state.settings || {}; // TODO: uncomment after api refactor
  const { has_scheduled_call } = controller.state?.settings || {};

  const setup =
    JSON.parse(
      controller.state.settings?.testing_preferences?.onboarding_step || "{}",
    ) || {};

  return { ...setup, has_scheduled_call };
};

const toggleTimerCardPreferences = (
  controller,
  show_timer_card,
  cb = () => {},
) => {
  const settings = controller.state?.settings || {};
  updatePreferences(controller, { ...settings, show_timer_card }, () => {
    controller.getItems();
    cb();
  });
};

// ------------------------------------- LOCAL STORAGE -------------------------------------
const getPreferencesStorageKey = (controller) => {
  return getStorageKey(controller, "PREFERENCES");
};

const wasTutorialOverlaySeen = (controller, key) => {
  const tutorialPrefs = _getTutorialPreferences(controller);
  return tutorialPrefs[key];
};

const updateTutorialStatus = (controller, data) => {
  const oldTutorialsPrefs = _getTutorialPreferences(controller);
  const newTutorialSettings = {
    tutorials_overlay: { ...oldTutorialsPrefs, ...data },
  };

  updateTestPreferences(controller, newTutorialSettings, () => {
    // Refresh
    controller.getApiData("settings");
  });
};

const _getTutorialPreferences = (controller) => {
  return (
    JSON.parse(
      controller.state.settings?.testing_preferences?.tutorials_overlay || "{}",
    ) || {}
  );
};

// ------------------------------------- GENERIC DATA LOAD/STORE VALUE -------------------------------------
const loadData = (controller, key) => {
  return new Promise((resolve, reject) => {
    controller.apiService
      .cardAction({
        action: "dataload",
        key,
      })
      .then(
        (reply) => resolve(JSON.parse(reply)),
        (error) => reject(error),
      );
  });
};

const storeData = (controller, key, value) => {
  controller.apiService.cardAction({
    action: "datastore",
    key,
    value,
  });
};

const SettingsHelper = {
  updateSettings: updateTestPreferences,
  updatePreferences,
  updateSetupProgress,
  getCurrentSetupProgress,
  getPreferencesStorageKey,
  updateTutorialStatus,
  wasTutorialOverlaySeen,
  loadData,
  storeData,
  toggleTimerCardPreferences,
};

export default SettingsHelper;
